<div
  tooltipIfTruncated
  [tooltipIfTruncatedDisabled]="tooltipDisabled"
  [matTooltip]="transform(row[columnConfig.id], columnConfig)"
  [matTooltipClass]="'table-tooltip'"
  [class.placeholder]="hasPlaceholder(columnConfig)"
>
  {{ transform(row[columnConfig.id], columnConfig) }}
</div>
